/* GLAMO: stationary palette level and product-information dialogs.
   No filtering or details expansion in the page document, so mobile Safari
   cannot jump to the footer as the tall palette changes its height. */
(function(){
  'use strict';
  if (window.__glamoPaletteDialogV1) return;
  window.__glamoPaletteDialogV1 = true;

  var rowTypes = {
    'estel-de-luxe-kraska':'line0',
    'estel-de-luxe-silver-kraska':'silver',
    'estel-sensation-kraska':'line2',
    'elea-artisto-color-kraska':'line3',
    'elea-artisto-toner-lux':'line4',
    'bekeen-kraska':'line5',
    'bbcos-innovation-evo-kraska':'line6',
    'bbcos-earthia-color-kraska':'line7',
    'elea-artisto-funky-colors':'line8'
  };
  var copy = {
    lt:{close:'Uždaryti',shades:'Atspalviai',choose:'Pasirinkite atspalvį, kad peržiūrėtumėte nuotrauką ir galėtumėte jį įdėti į krepšelį.',info:'Informacija apie dažus',none:'Šio lygio atspalvių nerasta.'},
    ru:{close:'Закрыть',shades:'Оттенки',choose:'Выберите оттенок — откроется большое фото и возможность добавить товар в корзину.',info:'Информация о краске',none:'Оттенки для этого уровня не найдены.'},
    en:{close:'Close',shades:'Shades',choose:'Select a shade to see its large photo and the add-to-cart option.',info:'Hair colour information',none:'No shades in this level.'},
    uk:{close:'Закрити',shades:'Відтінки',choose:'Оберіть відтінок, щоб переглянути велике фото та додати товар до кошика.',info:'Інформація про фарбу',none:'Відтінків цього рівня не знайдено.'}
  };
  var current = null;
  function rootOf(element) {
    var root = element && element.closest && element.closest('#glamo-color-demo[data-glamo-page-mode="detail"]');
    return root && root.dataset.demoReady === '1' ? root : null;
  }
  function lang(root) {return copy[(root.dataset.demoBuyLocale||'lt').toLowerCase()]||copy.lt;}
  function elt(tag,cls,textContent) {
    var e=document.createElement(tag);
    if(cls)e.className=cls;
    if(textContent!==undefined)e.textContent=textContent;
    return e;
  }
  function clear() {
    if(!current)return;
    var previous=current;
    current=null;
    document.removeEventListener('keydown',onKey,true);
    previous.modal.remove();
    if(previous.trigger && previous.trigger.isConnected){
      try{previous.trigger.focus({preventScroll:true});}catch(ignore){}
    }
  }
  function onKey(e) {
    if(!current)return;
    // Keep the shade-row dialog open underneath the individual shade viewer.
    // Escape/Tab are handled by the topmost viewer until it is dismissed.
    if(document.querySelector('#glamo-shade-cart-v5,#glamo-v4-popup,#glamo-v3-popup'))return;
    if(e.key==='Escape'){e.preventDefault();e.stopImmediatePropagation();clear();return;}
    if(e.key!=='Tab')return;
    var all=Array.from(current.modal.querySelectorAll('button:not([disabled]),a[href]'))
      .filter(function(el){return el.getClientRects().length>0;});
    if(all.length===0)return;
    var first=all[0], last=all[all.length-1];
    if(e.shiftKey && document.activeElement===first){e.preventDefault();last.focus({preventScroll:true});}
    else if(!e.shiftKey && document.activeElement===last){e.preventDefault();first.focus({preventScroll:true});}
  }
  function open(root,trigger,title,description,fill) {
    clear();
    var words=lang(root);
    var mask=elt('div','glamo-palette-dialog');
    mask.setAttribute('role','presentation');
    var panel=elt('section','glamo-palette-dialog__panel');
    panel.setAttribute('role','dialog');
    panel.setAttribute('aria-modal','true');
    var headingId='glamo-palette-dialog-heading';
    panel.setAttribute('aria-labelledby',headingId);
    var header=elt('header','glamo-palette-dialog__head');
    var titleBox=elt('div','glamo-palette-dialog__titles');
    var h=elt('h2','glamo-palette-dialog__title',title);
    h.id=headingId;
    titleBox.appendChild(h);
    if(description)titleBox.appendChild(elt('p','glamo-palette-dialog__subtitle',description));
    var close=elt('button','glamo-palette-dialog__close','×');
    close.type='button';close.setAttribute('aria-label',words.close);
    close.addEventListener('click',clear);
    header.append(titleBox,close);
    var body=elt('div','glamo-palette-dialog__body');
    fill(body);
    panel.append(header,body);
    mask.appendChild(panel);
    mask.addEventListener('click',function(e){if(e.target===mask)clear();});
    // Put the fixed dialog directly under BODY, never inside the palette grid.
    document.body.insertBefore(mask,document.body.firstChild);
    current={modal:mask,trigger:trigger};
    document.addEventListener('keydown',onKey,true);
    try{close.focus({preventScroll:true});}catch(ignore){}
  }
  function openRow(root,trigger) {
    var words=lang(root);
    var palette=rowTypes[root.dataset.glamoDetailHandle];
    if(!palette)return;
    var level=trigger.dataset.demoSilverRow||trigger.dataset.demoDeluxeRow||
      trigger.dataset.demoArtistoRow||trigger.dataset.demoKeenRow||
      trigger.dataset.demoInnovationRow||trigger.dataset.demoEarthiaRow||'all';
    var all=Array.from(root.querySelectorAll('[data-demo-shade]')).filter(function(tile){
      return tile.dataset.demoPalette===palette;
    });
    var matching=all.filter(function(tile){
      return level==='all'||(tile.dataset.demoLevel||tile.dataset.demoShade.split(/[./]/)[0])===level;
    });
    var rangeName=(root.querySelector('[data-demo-line-name]')?.textContent||'').trim();
    var title=rangeName+' · '+words.shades+' '+trigger.textContent.trim();
    open(root,trigger,title,words.choose,function(body){
      if(matching.length===0){
        body.appendChild(elt('p','glamo-palette-dialog__empty',words.none));
        return;
      }
      var grid=elt('div','glamo-palette-dialog__grid');
      matching.forEach(function(tile){
        var code=tile.dataset.demoShade||'';
        var button=elt('button','glamo-palette-dialog__tile');
        button.type='button';
        button.setAttribute('aria-label',rangeName+' '+code);
        var photo=tile.dataset.demoOfficialImage;
        var square=elt('span','glamo-palette-dialog__swatch');
        if(photo){
          var img=elt('img','glamo-palette-dialog__image');
          img.src=photo;img.alt='';
          img.loading='lazy';img.decoding='async';
          square.appendChild(img);
        } else {
          var color=tile.dataset.demoHex||'';
          if(/^#[0-9a-f]{3,8}$/i.test(color))square.style.backgroundColor=color;
          square.appendChild(elt('span','glamo-palette-dialog__placeholder',code));
        }
        button.append(square,elt('strong','glamo-palette-dialog__code',code));
        var name=(tile.dataset.demoShadeName||'').trim();
        if(name)button.appendChild(elt('small','glamo-palette-dialog__shade-name',name));
        button.addEventListener('click',function(){
          // Delegate to the existing shade viewer (including its cart button).
          // Do not trigger the old level filter or resize the original palette.
          // Preserve the row dialog so closing the shade returns to this grid.
          // Focusing the selected tile also restores keyboard position on return.
          try{button.focus({preventScroll:true});}catch(ignore){}
          tile.click();
        });
        grid.appendChild(button);
      });
      body.appendChild(grid);
    });
  }
  function openInfo(root,trigger) {
    var words=lang(root);
    var details=trigger.parentElement;
    if(!details||details.tagName!=='DETAILS')return;
    var title=trigger.textContent.replace('⌄','').trim();
    var range=(root.querySelector('[data-demo-line-name]')?.textContent||'').trim();
    open(root,trigger,range+' · '+title,'',function(body){
      var chart=details.querySelector('img');
      if(chart){
        var img=elt('img','glamo-palette-dialog__chart');
        img.src=chart.currentSrc||chart.src;img.alt=chart.alt||title;
        img.loading='eager';
        body.appendChild(img);
      }
      details.querySelectorAll('[data-info-value],p').forEach(function(el){
        var value=(el.textContent||'').trim();
        if(value)body.appendChild(elt('p','glamo-palette-dialog__text',value));
      });
    });
  }
  // Native row handlers live on each button. The capture interception here
  // avoids running those handlers, which hid most tiles and resized the page.
  window.addEventListener('click',function(e){
    var target=e.target;
    if(!target||!target.closest)return;
    var row=target.closest('.glamo-demo__deluxe-row');
    var summary=target.closest('.glamo-demo__info-item > summary, .glamo-demo__official-chart > summary');
    var clicked=row||summary;
    if(!clicked)return;
    var root=rootOf(clicked);
    if(!root)return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if(row)openRow(root,row);
    else openInfo(root,summary);
  },true);
})();
